var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComputerIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 52,
    viewBox: "0 0 70 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_224_5751)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.3333 43.2691C61.5417 43.2691 64.1375 40.6788 64.1375 37.5129L64.1667 8.73181C64.1667 5.56588 61.5417 2.97559 58.3333 2.97559H11.6667C8.45833 2.97559 5.83333 5.56588 5.83333 8.73181V37.5129C5.83333 40.6788 8.45833 43.2691 11.6667 43.2691H2.91667C1.3125 43.2691 0 44.5643 0 46.1472C0 47.7302 1.3125 49.0253 2.91667 49.0253H67.0833C68.6875 49.0253 70 47.7302 70 46.1472C70 44.5643 68.6875 43.2691 67.0833 43.2691H58.3333ZM14.5833 8.73181H55.4167C57.0208 8.73181 58.3333 10.027 58.3333 11.6099V34.6348C58.3333 36.2178 57.0208 37.5129 55.4167 37.5129H14.5833C12.9792 37.5129 11.6667 36.2178 11.6667 34.6348V11.6099C11.6667 10.027 12.9792 8.73181 14.5833 8.73181Z",
    fill: "#183864"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_224_5751"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputerIcon);
export default __webpack_public_path__ + "static/media/computerIcon.66daa894e0169406349fe97130a79494.svg";
export { ForwardRef as ReactComponent };